/**
 * Constants Se utiliza solo para guardar variables globales.
 * @author Santiago V. <snippetdeveloper@gmail.com>
 * @copyright (c) 2019 Snippet Developer.
 */

export const URL_BASE = 'https://www.snippetdeveloper.com/';
